/* ============================================================
   PBK ジュエリー商品一覧 — 全クライアント（JS）方式アプリ本体
   ルース版 pbk-loose-facets.js の複製 + フィルタ拡張（カテゴリ / サイズ / 地金素材）。
   JSON island を読み → 導出（石種 / 言葉 / カテゴリ / 素材 / 号数 / 表示名）→
   フィルタ(AND) / ソート / 無限スクロール(20件ずつ) / 均一カード生成 を全部担う。
   root は [data-pbk-jewelry]（ルースの [data-pbk-loose] と名前空間分離）。
   category/metal/stone は固定語彙を常時全件表示（在庫0件でも選択可・Figma仕様）。
   ringSize/necklace は実データ由来のためこれまで通り値がある分だけ動的生成。
   ============================================================ */
(function () {
  'use strict';

  var PAGE_SIZE = 20;
  var SIZES = ['min', 'base', 'max']; /* min=最多列(小) / base=既定 / max=最少列(大) */
  /* 追従UIが出てからフッターに隠されるまでに最低限確保したいスクロール幅(px)。
     これを下回るページ（＝一覧が短い）は is-foot を無効化し追従UIを出しっぱなしにする */
  var FOOT_MIN_WINDOW = 120;

  /* 既知石種語彙（tags 照合・石種フィルタ選択肢生成。Figma記載順・31種、末尾「その他」は未知石種の受け皿） */
  var STONE_VOCAB = [
    'アイオライト', 'アクアマリン', 'アゲート', 'アパタイト', 'アメシスト', 'アレキサンドライト',
    'アンダルサイト', 'アンモライト', 'エメラルド', 'オパール', 'ガーネット', 'カメオ',
    'クォーツ', 'クリソベリル', 'クンツァイト', 'コーネルピン', 'サファイア', 'サンゴ',
    'サンストーン', 'シトリン', 'ジルコン', 'スピネル', 'タンザナイト', 'ダイアモンド',
    'トパーズ', 'トルマリン', 'ペリドット', 'ムーンストーン', 'モルガナイト', 'ルビー', 'その他'
  ];

  /* カテゴリ語彙（表示順・チェックボックス）。custom.jewelry_category or タイトル/タグから導出。
     Figma は5種に分離（リング/ネックレス/ブレスレット/ピアス/イアリング） */
  var CATEGORY_VOCAB = ['リング', 'ネックレス', 'ブレスレット', 'ピアス', 'イアリング'];

  /* 地金素材グループ（表示順）。custom.metal or タイトル接頭辞から導出 */
  var METAL_GROUPS = ['プラチナ', 'ゴールド', 'シルバー'];

  /* ---------- ユーティリティ ---------- */
  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function toNum(v) {
    if (v == null || v === '') return null;
    var n = parseFloat(v);
    return isNaN(n) ? null : n;
  }

  /* 2文字コード（RG/NC/PI 等）を latin 境界付きで検出（語中の誤ヒット回避） */
  function hasCode(hay, code) {
    return new RegExp('(?:^|[^A-Za-z])' + code + '(?:[^A-Za-z]|$)').test(hay);
  }
  function anyCode(hay, codes) {
    for (var i = 0; i < codes.length; i++) { if (hasCode(hay, codes[i])) return true; }
    return false;
  }

  /* ---------- 導出: 石種（custom.stone_name 優先・語彙へ部分一致 → tags フォールバック） ---------- */
  /* 表記ゆれ正規化: 実データ「ダイヤモンド」↔ 語彙「ダイアモンド」等のヤ/ア差を吸収 */
  function normStone(s) {
    return String(s || '').replace(/ダイヤ/g, 'ダイア').replace(/アメジスト/g, 'アメシスト');
  }
  function deriveStone(product) {
    // 石名(stone) → 親石種(stone_type) が正。2層データ(PR #192)が入っていればそれを使う
    var type = product.stone_type;
    if (type) {
      var tn = normStone(type);
      for (var m = 0; m < STONE_VOCAB.length; m++) {
        if (STONE_VOCAB[m] === 'その他') continue;
        if (tn.indexOf(STONE_VOCAB[m]) !== -1) return STONE_VOCAB[m];
      }
    }
    var name = product.stone_name;
    if (name) {
      var n = normStone(name);
      for (var k = 0; k < STONE_VOCAB.length; k++) {
        var vk = STONE_VOCAB[k];
        if (vk === 'その他') continue;
        if (n.indexOf(vk) !== -1) return vk;
      }
      // 語彙ミス（例 ツァボライト: 名前に傘石種を含まない変種）→ タグへフォールスルー
    }
    var tags = product.tags || [];
    for (var i = 0; i < STONE_VOCAB.length; i++) {
      var vocab = STONE_VOCAB[i];
      if (vocab === 'その他') continue;
      for (var j = 0; j < tags.length; j++) {
        if (tags[j] && normStone(tags[j]).indexOf(vocab) !== -1) {
          return vocab;
        }
      }
    }
    return 'その他';
  }

  /* ---------- 導出: 言葉タグ ----------
     island の words のみ（親石種 stone_type.words の既定 + 商品個別 custom.words を Liquid がマージ済）。
     CL #222: 通常の商品タグは言葉として扱わない（loose 側 pbk-loose-facets.js と同仕様）。 */
  function deriveWords(product) {
    var out = [];
    var island = Array.isArray(product.words) ? product.words : [];
    for (var i = 0; i < island.length; i++) {
      var w = String(island[i] || '').trim();
      if (w && out.indexOf(w) === -1) out.push(w);
    }
    return out;
  }

  /* ---------- 導出: 固有番号（SKU → custom.serial → 旧タイトル末尾の【…】） ---------- */
  function deriveCode(product) {
    if (product.code) return String(product.code).trim();
    var m = /【([^】]+)】\s*$/.exec(product.title || '');
    return m ? m[1].trim() : null;
  }

  /* ---------- 導出: カテゴリ（custom.jewelry_category or タイトル/タグ） ----------
     正規化: 統制語彙5種のいずれか / 判定不能は null（分類なし）。
     順序 = リング → ネックレス → ブレスレット → ピアス → イアリング。
     ただし「イヤリング/イアリング」は文字列に「リング」を内包するため、リング判定より前に確定させる。 */
  function canonCategory(s) {
    if (!s) return null;
    s = String(s);
    var lower = s.toLowerCase();
    if (s.indexOf('イアリング') !== -1 || s.indexOf('イヤリング') !== -1 ||
        s.indexOf('イヤーカフ') !== -1 || s.indexOf('イアーカフ') !== -1 ||
        lower.indexOf('ear cuff') !== -1 || lower.indexOf('ear-cuff') !== -1) return 'イアリング';
    if (s.indexOf('リング') !== -1 || s.indexOf('指輪') !== -1) return 'リング';
    if (s.indexOf('ネックレス') !== -1 || s.indexOf('ペンダント') !== -1) return 'ネックレス';
    if (s.indexOf('ブレス') !== -1) return 'ブレスレット';
    if (s.indexOf('ピア') !== -1) return 'ピアス';
    return null;
  }
  function deriveCategory(product) {
    var fromMeta = canonCategory(product.category);
    if (fromMeta) return fromMeta;
    var hay = (product.title || '') + ' ' + ((product.tags || []).join(' '));
    var byWord = canonCategory(hay);
    if (byWord) return byWord;
    /* 2文字コードでの導出（RG=リング / NC=ネックレス / BR=ブレス / PI=ピアス） */
    if (hasCode(hay, 'RG')) return 'リング';
    if (hasCode(hay, 'NC')) return 'ネックレス';
    if (hasCode(hay, 'BR')) return 'ブレスレット';
    if (hasCode(hay, 'PI')) return 'ピアス';
    return null;
  }

  /* ---------- 導出: 地金素材ラベル（表示用・メタフィールドのみ／タイトル重複回避） ---------- */
  function deriveMetalLabel(product) {
    return product.metal ? String(product.metal).trim() : null;
  }

  /* ---------- 導出: 地金素材グループ（フィルタ用・custom.metal or タイトル接頭辞） ----------
     Pt/PT/プラチナ→プラチナ / K10,K14,K18,K24,WG,YG,PG,ゴールド→ゴールド / SV,Silver,シルバー→シルバー */
  function deriveMetalGroup(product) {
    var hay = (product.metal ? String(product.metal) : '') + ' ' + (product.title || '');
    /* latin コードは hasCode で語境界チェック（deriveCategory と同基準）→ 語中部分列の誤ヒット回避 */
    if (/プラチナ/.test(hay) || anyCode(hay, ['Pt', 'PT'])) return 'プラチナ';
    if (/ゴールド/.test(hay) || anyCode(hay, ['K9', 'K10', 'K12', 'K14', 'K18', 'K24', '10K', '14K', '18K', '24K', 'WG', 'YG', 'PG'])) return 'ゴールド';
    if (/シルバー|[Ss]ilver/.test(hay) || anyCode(hay, ['SV'])) return 'シルバー';
    return null;
  }

  /* ---------- 導出: リング号数（list メタフィールド → 正規化数値文字列の配列） ---------- */
  function normRingSizes(product) {
    var raw = product.ring_size;
    var arr = Array.isArray(raw) ? raw : (raw != null && raw !== '' ? [raw] : []);
    var out = [];
    arr.forEach(function (v) {
      var n = toNum(v);
      if (n == null) return;
      var s = String(n);
      if (out.indexOf(s) === -1) out.push(s);
    });
    out.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
    return out;
  }

  /* ---------- 導出: 商品名の素地（【…】記法の正規化） ----------
     CL #224 デザイン（user-attachments 70bf7494）の名前は「アレキサンドライトリング」のように
     【】なし。dev データは「【K14タンザナイトNC】【7/24㉚】」= 商品名【】+ 品番【】の二連。
     ① 末尾の【品番】が deriveCode で採用された番号と一致するときだけ落とす（名前と [ 番号 ] の二重表示回避）
     ② 残りが【…】1組で丸ごと包まれていれば剥がす（内側に【】を含まないときのみ＝貪欲マッチ事故を防ぐ）
     production のように素の商品名なら ①② とも no-op。 */
  function cleanTitle(product) {
    var base = String(product.title == null ? '' : product.title).trim();
    var code = product.code ? String(product.code).trim() : '';
    if (code) {
      var tail = /【([^】]+)】\s*$/.exec(base);
      if (tail && tail[1].trim() === code) base = base.slice(0, tail.index).trim();
    }
    var wrapped = /^【([^【】]+)】$/.exec(base);
    if (wrapped) base = wrapped[1].trim();
    return base;
  }

  /* ---------- 導出: 表示名「<商品名> [ <品番> ]」 ----------
     CL #224「表記の仕方をデザインに合わせる」: デザインは 1行目=商品名 [ 番号 ] /
     2行目=素材 / ct / 号数（左）+ 価格（右）。ルース側（pbk-loose-facets.js deriveName）と同一記法。
     旧実装は 1行目に素材・ct・号数まで連結し、番号を「No. …」の別行に出していた。 */
  /* 表示名の「[ 品番 ]」を折り返し不可の塊にする（Issue #217）。
     SP 幅では「インペリアルトパーズ [ 」/「P118 ]」のように括弧の直後で改行され、
     品番が 2 行に割れて読みづらかった。石名側は自然折返しのままにする。 */
  function nameHtml(name) {
    var s = escapeHtml(name || '');
    return s.replace(/(\[\s[^\[\]]+\s\])$/, '<span class="pbk-lcard__code">$1</span>');
  }

  function deriveName(product) {
    var base = cleanTitle(product);
    var code = product.code ? String(product.code).trim() : '';
    if (base && code) return base + ' [ ' + code + ' ]';
    return base;
  }

  /* ---------- 導出: スペック行「<素材> / <ct> / <号数>[ / <cm>]」（CL #224 デザイン = "Pt900 / 0.21ct / 11号"）----------
     旧実装は「No. <品番>」だった（番号は deriveName の [ … ] へ移動）。欠損項目は省略。 */
  function deriveSpec(product) {
    var parts = [];
    if (product.metalLabel) parts.push(product.metalLabel);
    if (product._caratNum != null) parts.push(product._caratNum.toFixed(2) + 'ct');
    if (product._ringSizes && product._ringSizes.length) parts.push(product._ringSizes.join('・') + '号');
    if (product.category === 'ネックレス' && product._chainNum != null) parts.push(product._chainNum + 'cm');
    return parts.join(' / ');
  }

  /* ---------- 各商品へ導出値を付与 ---------- */
  function enrich(products) {
    products.forEach(function (p) {
      p.stone = deriveStone(p);
      p.code = deriveCode(p);
      p._words = deriveWords(p);
      p.category = deriveCategory(p);
      p.metalLabel = deriveMetalLabel(p);
      p.metalGroup = deriveMetalGroup(p);
      p._colors = Array.isArray(p.colors) ? p.colors : (p.colors ? [p.colors] : []);
      p._createdNum = toNum(p.created) || 0;
      p._caratNum = toNum(p.carat);
      p._ringSizes = normRingSizes(p);
      p._chainNum = toNum(p.chain_length_cm);
      p._priceNum = toNum(p.price) || 0;
      p._onSale = p.on_sale === true;
      p._compareStr = p.compare_str || '';
      p.displayName = deriveName(p);
      p.displaySpec = deriveSpec(p);
      p._searchBlob = ((p.title || '') + ' ' + (p.stone || '') + ' ' + (p.code || '') + ' ' + (p.metalLabel || '') + ' ' + (p.category || '')).toLowerCase();
    });
    return products;
  }

  /* ---------- フィルタ状態の読み取り（セクションルート全体から読む） ---------- */
  function readState(root) {
    if (!root) return { keyword: '', priceMin: null, priceMax: null, sale: false, caratMin: null, caratMax: null, colors: [], cert: false, shapes: [], stones: [], words: [], categories: [], metals: [], ringSizes: [], necklaceMin: null, necklaceMax: null };
    function val(sel) {
      var el = root.querySelector(sel);
      return el ? el.value : '';
    }
    function checkedVals(sel) {
      var out = [];
      root.querySelectorAll(sel).forEach(function (el) {
        if (el.checked) out.push(el.value);
      });
      return out;
    }
    /* ピッカー(色/形/言葉)はボタン + aria-pressed */
    function pressedVals(sel) {
      var out = [];
      root.querySelectorAll(sel).forEach(function (el) {
        if (el.getAttribute('aria-pressed') === 'true') out.push(el.value);
      });
      return out;
    }
    var kwEl = root.querySelector('[data-pbk-keyword]');
    var certEl = root.querySelector('[data-pbk-cert]');
    var saleEl = root.querySelector('[data-pbk-sale]');
    return {
      keyword: (kwEl ? kwEl.value : '').trim().toLowerCase(),
      priceMin: toNum(val('[data-pbk-price-min]')),
      priceMax: toNum(val('[data-pbk-price-max]')),
      sale: saleEl ? saleEl.checked : false,
      caratMin: toNum(val('[data-pbk-carat-min]')),
      caratMax: toNum(val('[data-pbk-carat-max]')),
      colors: pressedVals('[data-pbk-color]'),
      cert: certEl ? certEl.checked : false,
      shapes: pressedVals('[data-pbk-shape]'),
      stones: checkedVals('[data-pbk-stone-list] [data-pbk-stone]'),
      words: pressedVals('[data-pbk-word]'),
      categories: checkedVals('[data-pbk-category-list] [data-pbk-category]'),
      metals: checkedVals('[data-pbk-metal-list] [data-pbk-metal]'),
      ringSizes: checkedVals('[data-pbk-ring-size-list] [data-pbk-ring-size]'),
      necklaceMin: toNum(val('[data-pbk-necklace-min]')),
      necklaceMax: toNum(val('[data-pbk-necklace-max]'))
    };
  }

  /* ---------- フィルタ適用（AND across groups / OR within group） ---------- */
  function applyFilters(products, st) {
    return products.filter(function (p) {
      if (st.keyword && p._searchBlob.indexOf(st.keyword) === -1) return false;

      if (st.priceMin != null && p._priceNum < st.priceMin) return false;
      if (st.priceMax != null && p._priceNum > st.priceMax) return false;

      if (st.sale && !p._onSale) return false;

      /* カテゴリ（単一値・OR） */
      if (st.categories.length && st.categories.indexOf(p.category) === -1) return false;

      /* 地金素材（単一値・OR） */
      if (st.metals.length && st.metals.indexOf(p.metalGroup) === -1) return false;

      /* リング号数（配列・OR。指定があり号数が無ければ除外） */
      if (st.ringSizes.length) {
        var rsHit = st.ringSizes.some(function (s) { return p._ringSizes.indexOf(s) !== -1; });
        if (!rsHit) return false;
      }

      /* ネックレス長 範囲: 両端含む。範囲指定があり長さ不明なら除外 */
      if (st.necklaceMin != null || st.necklaceMax != null) {
        if (p._chainNum == null) return false;
        if (st.necklaceMin != null && p._chainNum < st.necklaceMin) return false;
        if (st.necklaceMax != null && p._chainNum > st.necklaceMax) return false;
      }

      /* 重量範囲: 両端含む。範囲指定があり carat 不明なら除外 */
      if (st.caratMin != null || st.caratMax != null) {
        if (p._caratNum == null) return false;
        if (st.caratMin != null && p._caratNum < st.caratMin) return false;
        if (st.caratMax != null && p._caratNum > st.caratMax) return false;
      }

      if (st.colors.length) {
        var colorHit = st.colors.some(function (c) { return p._colors.indexOf(c) !== -1; });
        if (!colorHit) return false;
      }

      /* 鑑別書: custom.certificate は鑑別機関の metaobject 参照（{name:'GSJ'} 等）。
         旧実装は boolean 時代の `!== true` 判定のままで、常に 0 件になっていた */
      if (st.cert && !p.cert) return false;

      if (st.shapes.length && st.shapes.indexOf(p.shape) === -1) return false;

      if (st.stones.length && st.stones.indexOf(p.stone) === -1) return false;

      if (st.words.length) {
        var wordHit = st.words.some(function (w) { return p._words.indexOf(w) !== -1; });
        if (!wordHit) return false;
      }

      return true;
    });
  }

  /* ---------- ソート ---------- */
  function sortProducts(products, sortBy) {
    var arr = products.slice();
    if (sortBy === 'price-ascending') {
      arr.sort(function (a, b) { return a._priceNum - b._priceNum; });
    } else if (sortBy === 'price-descending') {
      arr.sort(function (a, b) { return b._priceNum - a._priceNum; });
    } else {
      /* created-descending（新着順・既定） */
      arr.sort(function (a, b) { return b._createdNum - a._createdNum; });
    }
    return arr;
  }

  /* ---------- カード HTML 生成（ルース版と同構造）
     下部 = 名前行「<商品名> <素材>/<ct>/<号数>」+ スペック行「品番」と価格(右) ---------- */
  function cardHtml(p, eager, order) {
    /* お気に入り線ハート = Figma 共通アイコン pbk-icon-fav-line と同一パス（自作禁止）。
       viewBox はグリフ密着 bbox（x0.5002 y1.8984 w15.6951 h14.0＝Figma icon_fav 15.695×14 と一致）→ CSS の高さ指定＝可視ハート高さ、下パスのはみ出しも解消（レビュー指摘 1854750167/1856723082）。サイズは pbk-collection-jewelry.css で PC14/SP10 指定 */
    var favSvg = '<svg class="pbk-lcard__fav-icon" viewBox="0.5002 1.8984 15.6951 14" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M8.3494 3.78573C6.04138 1.25748 3.35456 1.49533 1.6808 3.16908C0.00704669 4.84284 0.209659 7.37109 1.6808 9.22984C3.25766 11.2295 8.3494 15.8984 8.3494 15.8984C8.3494 15.8984 13.4411 11.2207 15.018 9.22984C16.4803 7.37109 16.6917 4.84284 15.018 3.16908C13.3442 1.49533 10.6574 1.25748 8.3494 3.78573Z" stroke="currentColor" stroke-miterlimit="10" fill="none"/></svg>';

    /* バッジ: 在庫切れは現行サイト（旧テーマ card-product の badge-soldout）と同じく
       「売り切れ」を出す。SALE と同じ位置なので在庫切れを優先（同時には出さない） */
    var soldOut = p.available === false;
    var saleHtml = soldOut
      ? '<span class="pbk-lcard__badge pbk-lcard__badge--soldout">SOLD&nbsp;&nbsp;OUT</span>'
      : (p._onSale ? '<span class="pbk-lcard__badge">SALE</span>' : '');

    var stoneInner;
    if (p.img) {
      stoneInner = '<img class="pbk-lcard__img pbk-lcard__img--primary" src="' + escapeHtml(p.img) + '" alt="' + escapeHtml(p.title) +
        '" loading="' + (eager ? 'eager' : 'lazy') + '" decoding="async">';
      /* 2枚目画像があればホバー用に重ねる（CSS がクロスフェード。装飾扱いで alt 空） */
      if (p.img2) {
        stoneInner += '<img class="pbk-lcard__img pbk-lcard__img--secondary" src="' + escapeHtml(p.img2) +
          '" alt="" aria-hidden="true" loading="lazy" decoding="async">';
      }
    } else {
      stoneInner = '<span class="pbk-lcard__placeholder" aria-hidden="true"></span>';
    }

    /* 価格: セール時は 旧価格(取消線・灰) + 売価(accent 橙) */
    var priceHtml;
    if (p._onSale && p._compareStr) {
      priceHtml = '<s class="pbk-lcard__price-was">' + escapeHtml(p._compareStr) + '</s>' +
        '<span class="pbk-lcard__price-now">' + escapeHtml(p.price_str) + '</span>';
    } else if (p.price_varies) {
      priceHtml = escapeHtml(p.price_min_str) + '〜';
    } else {
      priceHtml = escapeHtml(p.price_str);
    }

    var specHtml = p.displaySpec
      ? '<span class="pbk-lcard__spec">' + escapeHtml(p.displaySpec) + '</span>'
      : '<span class="pbk-lcard__spec"></span>';

    /* is-enter + --pbk-i = 順次出現アニメ（CSS 側で reduced-motion 時は無効） */
    return '<li class="pbk-lcard is-enter' + (p._onSale ? ' is-sale' : '') + '" style="--pbk-i:' + order + '">' +
      '<a class="pbk-lcard__link" href="' + escapeHtml(p.url) + '" aria-label="' + escapeHtml(p.title) + '">' +
        '<span class="pbk-lcard__stone">' + stoneInner + '</span>' +
        saleHtml +
        '<span class="pbk-lcard__meta">' +
          '<span class="pbk-lcard__name">' + nameHtml(p.displayName) + '</span>' +
          '<span class="pbk-lcard__row">' +
            specHtml +
            '<span class="pbk-lcard__price">' + priceHtml + '</span>' +
          '</span>' +
        '</span>' +
      '</a>' +
      '<button type="button" class="pbk-lcard__fav" aria-label="お気に入りに追加" aria-pressed="false" data-pbk-fav' +
        ' data-product-handle="' + escapeHtml(p.handle) + '" data-product-id="' + escapeHtml(p.id) + '" data-product-variant="' + escapeHtml(String(p.variant || '')) + '">' +
        favSvg +
      '</button>' +
    '</li>';
  }

  /* ---------- Section Rendering API で残ページ取得 → 商品配列に結合 ---------- */
  function fetchRemainingPages(meta) {
    var promises = [];
    var viewParam = meta.view ? ('view=' + encodeURIComponent(meta.view) + '&') : '';
    for (var page = 2; page <= meta.total_pages; page++) {
      var url = meta.collection_url + '?' + viewParam + 'section_id=' + encodeURIComponent(meta.section_id) + '&page=' + page;
      promises.push(
        fetch(url)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html) return [];
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var island = doc.querySelector('[data-pbk-products]');
            if (!island) return [];
            try {
              var data = JSON.parse(island.textContent);
              return (data && data.products) || [];
            } catch (e) {
              return [];
            }
          })
          .catch(function () { return []; })
      );
    }
    return Promise.all(promises).then(function (chunks) {
      var merged = [];
      chunks.forEach(function (c) { merged = merged.concat(c); });
      return merged;
    });
  }

  /* ============================================================
     アプリ初期化（1 セクション分）
     ============================================================ */
  function initApp(rootEl) {
    var island = rootEl.querySelector('[data-pbk-products]');
    if (!island) return;

    var parsed;
    try {
      parsed = JSON.parse(island.textContent);
    } catch (e) {
      return;
    }

    var meta = parsed.meta || {};
    var allProducts = enrich((parsed.products || []).slice());

    /* URL の ?stone=石種 (カンマ区切り/複数指定可) を初期チェック状態のシードにする
       (トップ KV の石クリック導線)。表記ゆれは normStone で語彙へ寄せる。語彙外は無視。 */
    var urlStones = [];
    try {
      new URLSearchParams(location.search).getAll('stone').forEach(function (raw) {
        raw.split(',').forEach(function (s) {
          s = normStone(s.trim());
          if (s && STONE_VOCAB.indexOf(s) !== -1 && urlStones.indexOf(s) === -1) urlStones.push(s);
        });
      });
    } catch (e) { /* URLSearchParams 非対応環境はシードなしで続行 */ }

    /* URL の ?category=カテゴリ (カンマ区切り/複数指定可) も同様にシードする
       (サイズの測り方ページ末尾 RING/NECKLACE カード導線)。
       表記ゆれ（指輪/イヤリング等）は canonCategory で統制語彙へ寄せる。語彙外は無視。 */
    var urlCategories = [];
    try {
      new URLSearchParams(location.search).getAll('category').forEach(function (raw) {
        raw.split(',').forEach(function (s) {
          var c = canonCategory(s.trim());
          if (c && urlCategories.indexOf(c) === -1) urlCategories.push(c);
        });
      });
    } catch (e) { /* URLSearchParams 非対応環境はシードなしで続行 */ }

    var grid = rootEl.querySelector('#product-grid');
    var countEl = rootEl.querySelector('[data-pbk-count]');
    var emptyEl = rootEl.querySelector('[data-pbk-empty]');
    var loadingEl = rootEl.querySelector('[data-pbk-loading]');
    var sentinel = rootEl.querySelector('[data-pbk-sentinel]');
    var filtersRoot = rootEl.querySelector('[data-pbk-filters]');
    var scrimEl = rootEl.querySelector('[data-pbk-scrim]');
    /* 並べ替えは操作行 + 追従バーの2箇所に出るため全件を保持し値を同期する */
    var sortEls = [].slice.call(rootEl.querySelectorAll('[data-pbk-sort]'));
    var stickyEl = rootEl.querySelector('[data-pbk-sticky]');
    /* is-foot の交差判定に使う追従UI実体（PC=丸ボタン / SP=ヘッダー直下バー・右上サイズ±） */
    var fabEl = rootEl.querySelector('.pbk-loose__fab');
    var stickyBarEl = rootEl.querySelector('.pbk-loose__stickybar');
    var sizeEl = rootEl.querySelector('.pbk-loose-bar__size');
    var barEl = rootEl.querySelector('.pbk-loose__bar');
    var headerEl = document.querySelector('.pbk-header-bar, header.header, #shopify-section-header header');
    var footerEl = document.querySelector('.pbk-footer, footer.footer, .footer, #shopify-section-footer');

    var pickerEls = {};
    rootEl.querySelectorAll('[data-pbk-picker]').forEach(function (el) {
      pickerEls[el.getAttribute('data-pbk-picker')] = el;
    });
    var bottomBarEl = rootEl.querySelector('[data-pbk-bottombar]');

    var filtered = [];
    var rendered = 0;
    var observer = null;

    function currentSort() { return sortEls.length ? sortEls[0].value : 'created-descending'; }

    /* 追従UI の実矩形。display:none の要素は 0 サイズになるので自動的に判定対象から外れる */
    function uiRect(el) {
      if (!el) return null;
      var r = el.getBoundingClientRect();
      return (r.width > 0 && r.height > 0) ? r : null;
    }
    function overlaps(a, b) {
      return !!a && !!b && a.top < b.bottom && a.bottom > b.top && a.left < b.right && a.right > b.left;
    }

    /* ---------- 追従UI（操作行がヘッダー下に隠れたら出す） ---------- */
    function updateSticky() {
      var hb = 0;
      if (headerEl) {
        var hr = headerEl.getBoundingClientRect();
        hb = Math.max(0, hr.bottom);
      }
      rootEl.style.setProperty('--pbk-header-h', hb + 'px');
      if (!barEl) return;
      var barBottom = barEl.getBoundingClientRect().bottom;
      var on = barBottom < hb + 8;
      rootEl.classList.toggle('is-sticky', on);
      if (stickyEl) stickyEl.hidden = !on;
      /* FOOT エリア進入で追従UI（絞り込みfab / サイズ変更・ボトムバー）をフェードアウト
         （レビュー 3700:73122 絞り込みbtn / 3700:73123 サイズ変更btn「FOOTエリアに入ったらフェードアウト」）。
         判定は「フッターが画面内に入ったか」の近接ではなく追従UIとフッターの実矩形交差にする。
         加えて、絞り込みで一覧が短くなるとフッターが常時画面内＝is-foot が外れず追従UIが
         一度も出せなくなるため「追従UIが出てからフッターが届くまでの有効スクロール幅」を先に見て、
         幅が取れないページでは is-foot 自体を無効化する（短い一覧でも必ず操作できる状態を残す）。
         長い一覧では footAt >> onAt なので従来どおりの出現/消滅になる */
      var sy = window.pageYOffset || document.documentElement.scrollTop || 0;
      var footRect = footerEl ? footerEl.getBoundingClientRect() : null;
      var footHit = false;
      if (footRect) {
        var barRect = uiRect(bottomBarEl);
        /* onAt = 追従UIが出るスクロール量 / footAt = フッターがボトムバー帯に掛かるスクロール量 */
        var onAt = (barBottom + sy) - hb - 8;
        var footAt = barRect ? (footRect.top + sy) - barRect.bottom : Infinity;
        if (footAt > onAt + FOOT_MIN_WINDOW) {
          footHit = overlaps(barRect, footRect) ||
            overlaps(uiRect(fabEl), footRect) ||
            overlaps(uiRect(stickyBarEl), footRect) ||
            overlaps(uiRect(sizeEl), footRect);
        }
      }
      rootEl.classList.toggle('is-foot', footHit);
    }

    /* ---------- パネル/ピッカー 排他制御 ---------- */
    var openPanel = null;
    var scrollY = 0;
    /* パネル展開中に確定したスクロール先。閉じた直後にスムーススクロールで消化する */
    var pendingScrollTop = null;

    function lockBody() {
      scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add('pbk-noscroll');
      document.body.style.top = (-scrollY) + 'px';
    }
    function unlockBody() {
      if (!document.documentElement.classList.contains('pbk-noscroll')) return;
      document.documentElement.classList.remove('pbk-noscroll');
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
    }

    function setPanel(name) {
      name = name || null;
      openPanel = name;
      if (filtersRoot) {
        var fOpen = (name === 'filter');
        filtersRoot.classList.toggle('is-open', fOpen);
        filtersRoot.setAttribute('aria-hidden', fOpen ? 'false' : 'true');
      }
      Object.keys(pickerEls).forEach(function (k) {
        var pOpen = (name === k);
        pickerEls[k].classList.toggle('is-open', pOpen);
        pickerEls[k].setAttribute('aria-hidden', pOpen ? 'false' : 'true');
      });
      /* ピッカー展開中は 3ピルを隠し、同じ位置に扇形 UI を出す（−/+ は据置） */
      if (bottomBarEl) {
        bottomBarEl.classList.toggle('is-picker', !!(name && pickerEls[name]));
      }
      /* 暗幕の表示は CSS（[data-pbk-panel="filter"]）に委譲。hidden 属性だと閉じるフェードが効かない */
      /* 言葉ピッカーを開く直前に ← の逃げを再計算（生成時は Web フォント未適用の pill 幅で
         折返しが変わり、× が最終行の pill に重なることがある = CL #123・loose と同期） */
      if (name === 'word') layoutWordBack();
      if (name === 'filter') { lockBody(); } else { unlockBody(); flushPendingScroll(); }
      rootEl.querySelectorAll('[data-pbk-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', b.getAttribute('data-pbk-open') === name ? 'true' : 'false');
      });
      rootEl.setAttribute('data-pbk-panel', name || '');
    }

    /* ---------- サイズ（列数）トグル ---------- */
    function updateSizeButtons() {
      var cur = rootEl.getAttribute('data-pbk-size') || 'base';
      var i = SIZES.indexOf(cur);
      var dec = rootEl.querySelector('[data-pbk-size-dec]');
      var inc = rootEl.querySelector('[data-pbk-size-inc]');
      if (dec) dec.disabled = (i <= 0);
      if (inc) inc.disabled = (i >= SIZES.length - 1);
    }
    function setSize(dir) {
      var cur = rootEl.getAttribute('data-pbk-size') || 'base';
      var i = SIZES.indexOf(cur);
      if (i === -1) i = 1;
      i = Math.min(SIZES.length - 1, Math.max(0, i + dir));
      rootEl.setAttribute('data-pbk-size', SIZES[i]);
      updateSizeButtons();
    }

    /* 石種チェックリストを統制語彙から常時全件生成（在庫0件でも選択可・Figma仕様） */
    function buildStoneList() {
      var listEl = rootEl.querySelector('[data-pbk-stone-list]');
      if (!listEl) return;
      var checked = {};
      listEl.querySelectorAll('[data-pbk-stone]').forEach(function (el) {
        if (el.checked) checked[el.value] = true;
      });
      var present = {};
      allProducts.forEach(function (p) { if (p.stone) present[p.stone] = true; });
      urlStones = urlStones.filter(function (name) {
        if (!present[name]) return true; /* 未出現の石種は次回 build まで持ち越し */
        checked[name] = true;
        return false;
      });
      var html = '';
      STONE_VOCAB.forEach(function (name) {
        html += '<label class="pbk-check">' +
          '<input type="checkbox" class="pbk-check__input" data-pbk-stone' + (checked[name] ? ' checked' : '') + ' value="' + escapeHtml(name) + '">' +
          '<span class="pbk-check__box" aria-hidden="true"></span>' +
          '<span class="pbk-check__label">' + escapeHtml(name) + '</span>' +
        '</label>';
      });
      listEl.innerHTML = html;
    }

    /* カテゴリーチェックを統制語彙から常時全件生成（在庫0件でも選択可・Figma仕様）
       石種チェック(buildStoneList) と同じ markup / data 属性命名（data-pbk-category）を踏襲 */
    function buildCategoryList() {
      var listEl = rootEl.querySelector('[data-pbk-category-list]');
      var facetEl = rootEl.querySelector('[data-pbk-facet="category"]');
      if (!listEl) return;
      var checked = {};
      listEl.querySelectorAll('[data-pbk-category]').forEach(function (el) {
        if (el.checked) checked[el.value] = true;
      });
      var present = {};
      allProducts.forEach(function (p) { if (p.category) present[p.category] = true; });
      urlCategories = urlCategories.filter(function (name) {
        if (!present[name]) return true; /* 未出現カテゴリは次回 build まで持ち越し（石種と同パターン） */
        checked[name] = true;
        return false;
      });
      var html = '';
      CATEGORY_VOCAB.forEach(function (name) {
        html += '<label class="pbk-check">' +
          '<input type="checkbox" class="pbk-check__input" data-pbk-category' + (checked[name] ? ' checked' : '') + ' value="' + escapeHtml(name) + '">' +
          '<span class="pbk-check__box" aria-hidden="true"></span>' +
          '<span class="pbk-check__label">' + escapeHtml(name) + '</span>' +
        '</label>';
      });
      listEl.innerHTML = html;
      if (facetEl) facetEl.hidden = false;
    }

    /* 地金素材チェックを統制語彙から常時全件生成（在庫0件でも選択可・Figma仕様） */
    function buildMetalList() {
      var listEl = rootEl.querySelector('[data-pbk-metal-list]');
      var facetEl = rootEl.querySelector('[data-pbk-facet="metal"]');
      if (!listEl) return;
      var checked = {};
      listEl.querySelectorAll('[data-pbk-metal]').forEach(function (el) {
        if (el.checked) checked[el.value] = true;
      });
      var html = '';
      METAL_GROUPS.forEach(function (name) {
        html += '<label class="pbk-check">' +
          '<input type="checkbox" class="pbk-check__input" data-pbk-metal' + (checked[name] ? ' checked' : '') + ' value="' + escapeHtml(name) + '">' +
          '<span class="pbk-check__box" aria-hidden="true"></span>' +
          '<span class="pbk-check__label">' + escapeHtml(name) + '</span>' +
        '</label>';
      });
      listEl.innerHTML = html;
      if (facetEl) facetEl.hidden = false;
    }

    /* リング号数チェックを実データから動的生成（存在する号数のみ・昇順・無ければ subfacet 非表示） */
    function buildRingSizeList() {
      var listEl = rootEl.querySelector('[data-pbk-ring-size-list]');
      var subEl = rootEl.querySelector('[data-pbk-subfacet="ring-size"]');
      if (!listEl) return;
      var checked = {};
      listEl.querySelectorAll('[data-pbk-ring-size]').forEach(function (el) {
        if (el.checked) checked[el.value] = true;
      });
      var set = {};
      var sizes = [];
      allProducts.forEach(function (p) {
        (p._ringSizes || []).forEach(function (s) { if (!set[s]) { set[s] = true; sizes.push(s); } });
      });
      sizes.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
      var html = '';
      sizes.forEach(function (s) {
        html += '<label class="pbk-check">' +
          '<input type="checkbox" class="pbk-check__input" data-pbk-ring-size' + (checked[s] ? ' checked' : '') + ' value="' + escapeHtml(s) + '">' +
          '<span class="pbk-check__box" aria-hidden="true"></span>' +
          '<span class="pbk-check__label">' + escapeHtml(s) + '号</span>' +
        '</label>';
      });
      listEl.innerHTML = html;
      if (subEl) subEl.hidden = (html === '');
    }

    /* ネックレス長 レンジ選択肢を実データから動的生成（存在する長さのみ・昇順・無ければ subfacet 非表示） */
    function buildNecklaceLengthRange() {
      var minEl = rootEl.querySelector('[data-pbk-necklace-min]');
      var maxEl = rootEl.querySelector('[data-pbk-necklace-max]');
      var subEl = rootEl.querySelector('[data-pbk-subfacet="necklace"]');
      if (!minEl || !maxEl) return;
      var prevMin = minEl.value;
      var prevMax = maxEl.value;
      var set = {};
      var lens = [];
      allProducts.forEach(function (p) {
        if (p._chainNum != null && !set[p._chainNum]) { set[p._chainNum] = true; lens.push(p._chainNum); }
      });
      lens.sort(function (a, b) { return a - b; });
      var minOpts = '<option value="">下限なし</option>';
      var maxOpts = '<option value="">上限なし</option>';
      lens.forEach(function (n) {
        minOpts += '<option value="' + n + '">' + n + 'cm</option>';
        maxOpts += '<option value="' + n + '">' + n + 'cm</option>';
      });
      minEl.innerHTML = minOpts;
      maxEl.innerHTML = maxOpts;
      minEl.value = prevMin;
      maxEl.value = prevMax;
      if (subEl) subEl.hidden = (lens.length === 0);
    }

    /* サイズ facet 全体は、リング号数・ネックレス長の両サブブロックが空のとき hidden。
       各サブブロックの hidden 状態は buildRingSizeList / buildNecklaceLengthRange が設定済み。 */
    function updateSizeFacet() {
      var facetEl = rootEl.querySelector('[data-pbk-facet="size"]');
      if (!facetEl) return;
      var ringSub = rootEl.querySelector('[data-pbk-subfacet="ring-size"]');
      var neckSub = rootEl.querySelector('[data-pbk-subfacet="necklace"]');
      var ringEmpty = !ringSub || ringSub.hidden;
      var neckEmpty = !neckSub || neckSub.hidden;
      facetEl.hidden = (ringEmpty && neckEmpty);
    }

    /* 言葉タグ pill を実データから動的生成（非石種タグ・出現順） */
    function buildWordList() {
      var picker = rootEl.querySelector('[data-pbk-picker="word"]');
      var listEl = rootEl.querySelector('[data-pbk-word-list]');
      if (!listEl) return;
      /* ← ボタンは pill と同じ flex コンテナに差し込むので、innerHTML 差替の前に退避する */
      var back = picker ? picker.querySelector('.pbk-picker__back--word') : null;
      if (back && back.parentNode === listEl) picker.appendChild(back);

      var pressed = {};
      listEl.querySelectorAll('[data-pbk-word]').forEach(function (el) {
        if (el.getAttribute('aria-pressed') === 'true') pressed[el.value] = true;
      });
      var present = [];
      var seen = {};
      allProducts.forEach(function (p) {
        (p._words || []).forEach(function (w) { if (!seen[w]) { seen[w] = true; present.push(w); } });
      });
      if (!present.length) {
        listEl.innerHTML = '<p class="pbk-picker__empty">タグがありません</p>';
        layoutWordBack();
        return;
      }
      var html = '';
      present.forEach(function (w, i) {
        var on = pressed[w];
        /* --i = 出現 stagger 順（DOM 順 = 左上→右下）。CSS の pbk-picker-word-in が参照 */
        html += '<button type="button" class="pbk-word' + (on ? ' is-active' : '') + '" style="--i:' + i + '" data-pbk-word value="' + escapeHtml(w) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
          '<span class="pbk-word__hash" aria-hidden="true">#</span>' + escapeHtml(w) +
        '</button>';
      });
      listEl.innerHTML = html;
      layoutWordBack();
    }

    /* ← 戻るボタンは CSS で「下部・左右中央」に絶対固定（Figma 3683:113737・loose と同期）。
       ここでは listEl に不可視スペーサー（中央スロット+balance）を挿入して pill を back の左右へ振り分けるだけ。
       入り切らない/タグ無しは back を単独最下行へ（全幅スペーサーで 1 行確保）。 */
    function layoutWordBack() {
      layoutWordBackCore();
      assignWordVectors();
    }

    /* 出現アニメ用: 各 pill に「閉じるボタン（下部中央）中心 → pill 中心」ベクトルを
       --wdx/--wdy（px 数値）で付与。CSS の pbk-picker-word-in が始点
       （閉じるボタンから 70% 進んだ点 = 定位置の -30% 手前）に使う。
       ピッカーは閉時も opacity:0 でレイアウト済み・コンテナ transform は両者に等しく
       乗るため相対ベクトルは開閉状態に依らず正しい */
    function assignWordVectors() {
      var picker = rootEl.querySelector('[data-pbk-picker="word"]');
      var back = picker && picker.querySelector('.pbk-picker__back--word');
      var listEl = picker && picker.querySelector('[data-pbk-word-list]');
      if (!back || !listEl) return;
      var br = back.getBoundingClientRect();
      if (!br.width || !br.height) return;
      var bx = br.left + br.width / 2;
      var by = br.top + br.height / 2;
      [].slice.call(listEl.querySelectorAll('.pbk-word')).forEach(function (p) {
        var r = p.getBoundingClientRect();
        p.style.setProperty('--wdx', (r.left + r.width / 2 - bx).toFixed(1));
        p.style.setProperty('--wdy', (r.top + r.height / 2 - by).toFixed(1));
      });
    }

    function layoutWordBackCore() {
      var picker = rootEl.querySelector('[data-pbk-picker="word"]');
      if (!picker) return;
      var listEl = picker.querySelector('[data-pbk-word-list]');
      var back = picker.querySelector('.pbk-picker__back--word');
      if (!listEl || !back) return;
      if (back.parentNode === listEl) picker.appendChild(back);  /* 絶対配置なので listEl 外に保つ */
      [].slice.call(listEl.querySelectorAll('.pbk-word-spacer')).forEach(function (s) { s.parentNode.removeChild(s); });

      var bh = back.offsetHeight || 47;
      var bw = back.offsetWidth || 47;
      function sp(w, h, full) {
        var s = document.createElement('span');
        s.className = 'pbk-word-spacer';
        s.setAttribute('aria-hidden', 'true');
        s.style.pointerEvents = 'none';
        s.style.height = h + 'px';
        if (full) { s.style.flexBasis = '100%'; s.style.width = '100%'; }
        else { s.style.flex = '0 0 auto'; s.style.width = w + 'px'; }
        return s;
      }

      var pills = [].slice.call(listEl.querySelectorAll('.pbk-word'));
      if (!pills.length) { listEl.appendChild(sp(0, bh, true)); return; }

      var cs = getComputedStyle(listEl);
      var gap = parseFloat(cs.columnGap || cs.gap) || 10;
      var containerW = listEl.clientWidth;
      /* 確保する中央スロットは「ボタン幅 + gap」。balance スペーサーは |差| が gap 以下だと入れられず
         スロット中心が最大 gap/2 だけ中央からズレる（CL #123）ため、左右に gap/2 の逃げを持たせる */
      var slotW = bw + gap;

      var lastTop = pills[pills.length - 1].offsetTop;
      var lastRow = pills.filter(function (p) { return p.offsetTop === lastTop; });
      var wdt = lastRow.map(function (p) { return p.getBoundingClientRect().width; });
      var lastRowW = wdt.reduce(function (a, b) { return a + b; }, 0) + gap * Math.max(0, lastRow.length - 1);

      var bestK = 0, bestDelta = Infinity;
      for (var k = 0; k <= lastRow.length; k++) {
        var lm = k * gap, rm = (lastRow.length - k) * gap, i;
        for (i = 0; i < k; i++) lm += wdt[i];
        for (i = k; i < lastRow.length; i++) rm += wdt[i];
        if (Math.abs(lm - rm) < Math.abs(bestDelta)) { bestDelta = lm - rm; bestK = k; }
      }
      var balW = Math.abs(bestDelta) - gap;
      var needBal = balW >= 1;
      var need = lastRowW + slotW + gap + (needBal ? balW + gap : 0);
      if (need > containerW) { listEl.appendChild(sp(0, bh, true)); return; }

      var anchor = lastRow[bestK] || null;
      var slot = sp(slotW, bh, false);
      if (anchor) listEl.insertBefore(slot, anchor); else listEl.appendChild(slot);
      if (needBal) {
        var bal = sp(balW, 1, false);
        if (bestDelta > 0) listEl.appendChild(bal);
        else listEl.insertBefore(bal, bestK === 0 ? slot : lastRow[0]);
      }
      /* 最終保証: 実測して back と pill が重なっていたら back を単独最下行へ退避（CL #123） */
      if (overlapsPills(listEl, back)) {
        [].slice.call(listEl.querySelectorAll('.pbk-word-spacer')).forEach(function (s) { s.parentNode.removeChild(s); });
        listEl.appendChild(sp(0, bh, true));
      }
    }

    /* back（絶対配置・下部中央）が言葉 pill と実測で重なっているか */
    function overlapsPills(listEl, back) {
      var br = back.getBoundingClientRect();
      if (!br.width || !br.height) return false;
      return [].slice.call(listEl.querySelectorAll('.pbk-word')).some(function (p) {
        var r = p.getBoundingClientRect();
        return br.left < r.right - 0.5 && br.right > r.left + 0.5 && br.top < r.bottom - 0.5 && br.bottom > r.top + 0.5;
      });
    }

    /* ---------- 適用中フィルターの要約（loose と同仕様・ジュエリー固有の項目を追加） ----------
       PC: 操作行の下にチップ（Figma 4270:190924）。SP: フィルターボタン内に「・N」（4270:192006）。 */
    var CHIP_X_SVG = '<svg class="pbk-loose__chip-x" viewBox="0 0 9 9" fill="none" aria-hidden="true" focusable="false"><path d="M0.36541 0.36541L8.63459 8.63459" stroke="currentColor" stroke-width="1.03365"/><path d="M8.63459 0.36541L0.36541 8.63459" stroke="currentColor" stroke-width="1.03365"/></svg>';
    var chipsEl = rootEl.querySelector('[data-pbk-chips]');
    var chipListEl = rootEl.querySelector('[data-pbk-chip-list]');
    var filterCountEls = [].slice.call(rootEl.querySelectorAll('[data-pbk-filter-count]'));

    function selText(sel) {
      var el = rootEl.querySelector(sel);
      if (!el || !el.value) return '';
      var opt = el.options[el.selectedIndex];
      return opt ? opt.text.trim() : '';
    }

    function activeChips(st) {
      var out = [];
      if (st.keyword) out.push({ key: 'keyword', label: 'キーワード:' + st.keyword });
      if (st.categories.length) out.push({ key: 'category', label: 'カテゴリ:' + st.categories.join(',') });
      if (st.priceMin != null || st.priceMax != null) {
        out.push({ key: 'price', label: '価格:' + selText('[data-pbk-price-min]') + '-' + selText('[data-pbk-price-max]') });
      }
      if (st.sale) out.push({ key: 'sale', label: 'セール品' });
      if (st.caratMin != null || st.caratMax != null) {
        out.push({ key: 'carat', label: '重量:' + (st.caratMin != null ? st.caratMin + 'ct' : '') + '-' + (st.caratMax != null ? st.caratMax + 'ct' : '') });
      }
      if (st.cert) out.push({ key: 'cert', label: '鑑別書:あり' });
      if (st.metals.length) out.push({ key: 'metal', label: '素材:' + st.metals.join(',') });
      if (st.ringSizes.length) out.push({ key: 'ring-size', label: '号数:' + st.ringSizes.join(',') });
      if (st.necklaceMin != null || st.necklaceMax != null) {
        out.push({ key: 'necklace', label: '長さ:' + (st.necklaceMin != null ? st.necklaceMin + 'cm' : '') + '-' + (st.necklaceMax != null ? st.necklaceMax + 'cm' : '') });
      }
      if (st.stones.length) out.push({ key: 'stone', label: '石種:' + st.stones.join(',') });
      if (st.colors.length) out.push({ key: 'color', label: '色:' + st.colors.join(',') });
      if (st.shapes.length) out.push({ key: 'shape', label: '形:' + st.shapes.join(',') });
      if (st.words.length) out.push({ key: 'word', label: '言葉:' + st.words.join(',') });
      return out;
    }

    function renderChips(st) {
      var chips = activeChips(st);
      filterCountEls.forEach(function (el) {
        el.textContent = chips.length ? String(chips.length) : '';
        el.hidden = chips.length === 0;
      });
      if (!chipsEl || !chipListEl) return;
      if (!chips.length) {
        chipListEl.innerHTML = '';
        chipsEl.hidden = true;
        return;
      }
      chipListEl.innerHTML = chips.map(function (c) {
        return '<button type="button" class="pbk-loose__chip" data-pbk-chip="' + c.key + '"' +
          ' aria-label="' + escapeHtml(c.label) + ' の絞り込みを解除">' +
          '<span class="pbk-loose__chip-label">' + escapeHtml(c.label) + '</span>' + CHIP_X_SVG +
        '</button>';
      }).join('');
      chipsEl.hidden = false;
    }

    function clearGroup(key) {
      function uncheck(sel) { rootEl.querySelectorAll(sel).forEach(function (el) { el.checked = false; }); }
      function reset(sel) { rootEl.querySelectorAll(sel).forEach(function (el) { el.value = ''; }); }
      function unpress(sel) {
        rootEl.querySelectorAll(sel).forEach(function (el) {
          el.setAttribute('aria-pressed', 'false');
          el.classList.remove('is-active');
        });
      }
      if (key === 'keyword') {
        var kw = rootEl.querySelector('[data-pbk-keyword]');
        if (kw) kw.value = '';
      } else if (key === 'category') { uncheck('[data-pbk-category-list] [data-pbk-category]'); }
      else if (key === 'price') { reset('[data-pbk-price-min], [data-pbk-price-max]'); }
      else if (key === 'sale') { uncheck('[data-pbk-sale]'); }
      else if (key === 'carat') { reset('[data-pbk-carat-min], [data-pbk-carat-max]'); }
      else if (key === 'cert') { uncheck('[data-pbk-cert]'); }
      else if (key === 'metal') { uncheck('[data-pbk-metal-list] [data-pbk-metal]'); }
      else if (key === 'ring-size') { uncheck('[data-pbk-ring-size-list] [data-pbk-ring-size]'); }
      else if (key === 'necklace') { reset('[data-pbk-necklace-min], [data-pbk-necklace-max]'); }
      else if (key === 'stone') { uncheck('[data-pbk-stone-list] [data-pbk-stone]'); }
      else if (key === 'color') { unpress('[data-pbk-color]'); }
      else if (key === 'shape') { unpress('[data-pbk-shape]'); }
      else if (key === 'word') { unpress('[data-pbk-word]'); }
      render({ scroll: true });
    }

    /* ---------- フィルター更新後は一覧の先頭へ戻す（CL 追加要望） ----------
       パネル展開中は body が position:fixed（lockBody）なので即時スクロールは効かない。
       その場合は復元先の scrollY だけ書き換え、閉じたタイミングで先頭に戻す。 */
    /* 追従ヘッダーの実高。--pbk-header-h（updateSticky が rootEl へ書く）は縮むヘッダーに
       追従した途中値なので、sticky/fixed なヘッダー実測との大きい方を採る */
    function headerOffset() {
      var v = parseFloat(getComputedStyle(rootEl).getPropertyValue('--pbk-header-h')) || 0;
      var hdr = document.querySelector('.section-header, #shopify-section-header');
      if (hdr) {
        var pos = getComputedStyle(hdr).position;
        if (pos === 'sticky' || pos === 'fixed') v = Math.max(v, hdr.getBoundingClientRect().height);
      }
      return v;
    }

    function scrollToListTop() {
      var target = rootEl.querySelector('.pbk-loose__main') || grid;
      if (!target) return;
      /* チップ行の出し入れやカード差し替えでレイアウトが動くため、確定後（2 フレーム後）に測る */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var locked = document.documentElement.classList.contains('pbk-noscroll');
          var base = locked ? scrollY : (window.pageYOffset || document.documentElement.scrollTop || 0);
          var y = Math.max(0, Math.round(base + target.getBoundingClientRect().top - headerOffset() - 12));
          if (locked) { pendingScrollTop = y; return; }
          if (Math.abs(y - base) < 2) return;
          try { window.scrollTo({ top: y, behavior: 'smooth' }); }
          catch (e) { window.scrollTo(0, y); }
        });
      });
    }

    /* パネルを閉じたあとに保留分をスムーススクロールで消化（unlockBody が元位置へ戻した直後） */
    function flushPendingScroll() {
      if (pendingScrollTop == null) return;
      var y = pendingScrollTop;
      pendingScrollTop = null;
      requestAnimationFrame(function () {
        if (Math.abs(y - (window.pageYOffset || 0)) < 2) return;
        try { window.scrollTo({ top: y, behavior: 'smooth' }); }
        catch (e) { window.scrollTo(0, y); }
      });
    }

    function updateCount() {
      if (countEl) countEl.textContent = '全 ' + filtered.length.toLocaleString('ja-JP') + ' アイテム';
    }

    function updateSentinel() {
      if (!sentinel) return;
      sentinel.hidden = rendered >= filtered.length;
    }

    /* 残ページ結合を待つ間の「読み込み中」表示。件数(全 N アイテム)も途中値を出さない */
    function setLoading(on) {
      if (loadingEl) loadingEl.hidden = !on;
      if (on && countEl) countEl.textContent = '';
    }

    function appendBatch() {
      if (!grid) return;
      var next = filtered.slice(rendered, rendered + PAGE_SIZE);
      if (!next.length) { updateSentinel(); return; }
      var html = '';
      next.forEach(function (p, i) {
        /* 出現ディレイはバッチ内相対 index（追加読込も同じ尺で控えめに）。10 で頭打ち＝最大 400ms */
        html += cardHtml(p, (rendered + i) < 4, Math.min(i, 10));
      });
      grid.insertAdjacentHTML('beforeend', html);
      rendered += next.length;
      /* 差込んだ fav ボタンの初期状態(登録済ハート)を同期させる */
      document.dispatchEvent(new CustomEvent('pbk:cards-rendered'));
      updateSentinel();
      /* sentinel が可視域内に残ったままだと交差状態が変化せず次バッチが発火しない
         → 再観察で初期通知を強制し、画面が埋まるまで連鎖ロードさせる */
      if (observer && sentinel && !sentinel.hidden) {
        observer.unobserve(sentinel);
        observer.observe(sentinel);
      }
    }

    /* 0件表示（Issue #298）。絞り込み以前に商品が無い場合は他一覧と同じ「現在、〜はありません。」
       文言に差し替え、意味を持たない「絞り込みをすべて解除する」を隠す */
    function showEmpty() {
      if (!emptyEl) return;
      var noProducts = allProducts.length === 0;
      var msgEl = emptyEl.querySelector('[data-pbk-empty-msg]');
      var resetEl = emptyEl.querySelector('.pbk-loose__reset-link');
      if (msgEl) {
        msgEl.textContent = noProducts
          ? '現在、商品情報はありません。'
          : '条件に一致する商品が見つかりませんでした。';
      }
      if (resetEl) resetEl.hidden = noProducts;
      emptyEl.hidden = false;
    }

    function render(opts) {
      var st = readState(rootEl);
      filtered = sortProducts(applyFilters(allProducts, st), currentSort());
      rendered = 0;
      if (grid) grid.innerHTML = '';
      updateCount();
      renderChips(st);
      if (filtered.length === 0) {
        showEmpty();
        if (sentinel) sentinel.hidden = true;
        if (opts && opts.scroll) scrollToListTop();
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      appendBatch();
      if (opts && opts.scroll) scrollToListTop();
    }

    function clearAll() {
      if (filtersRoot) {
        filtersRoot.querySelectorAll('input[type="checkbox"]').forEach(function (el) { el.checked = false; });
        filtersRoot.querySelectorAll('select').forEach(function (el) { el.value = ''; });
        var kw = filtersRoot.querySelector('[data-pbk-keyword]');
        if (kw) kw.value = '';
      }
      /* ピッカー(色/形/言葉)の選択解除 */
      rootEl.querySelectorAll('[aria-pressed="true"]').forEach(function (el) {
        el.setAttribute('aria-pressed', 'false');
        el.classList.remove('is-active');
      });
      render({ scroll: true });
    }

    /* 無限スクロール */
    if (sentinel && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && rendered < filtered.length) appendBatch();
        });
      }, { rootMargin: '400px 0px' });
      observer.observe(sentinel);
    }

    /* ---------- イベント配線（セクションルートへ委譲） ---------- */
    rootEl.addEventListener('click', function (e) {
      /* 適用中フィルターのチップ ✕ → そのカテゴリだけ解除 */
      var chip = e.target.closest('[data-pbk-chip]');
      if (chip && rootEl.contains(chip)) {
        e.preventDefault();
        clearGroup(chip.getAttribute('data-pbk-chip'));
        return;
      }
      /* 色/形/言葉トグル */
      var toggle = e.target.closest('[data-pbk-color], [data-pbk-shape], [data-pbk-word]');
      if (toggle && rootEl.contains(toggle)) {
        var wasOn = toggle.getAttribute('aria-pressed') === 'true';
        toggle.setAttribute('aria-pressed', wasOn ? 'false' : 'true');
        toggle.classList.toggle('is-active', !wasOn);
        render({ scroll: true });
        return;
      }
      /* パネル/ピッカーを開く（同じものなら閉じる） */
      var opener = e.target.closest('[data-pbk-open]');
      if (opener && rootEl.contains(opener)) {
        var name = opener.getAttribute('data-pbk-open');
        setPanel(openPanel === name ? null : name);
        return;
      }
      /* 閉じる（×・←・適用ボタン） */
      if (e.target.closest('[data-pbk-close]')) { setPanel(null); return; }
      /* 暗幕クリックで閉じる */
      if (e.target.closest('[data-pbk-scrim]')) { setPanel(null); return; }
      /* サイズ − / + */
      if (e.target.closest('[data-pbk-size-dec]')) { setSize(-1); return; }
      if (e.target.closest('[data-pbk-size-inc]')) { setSize(1); return; }
      /* クリア */
      if (e.target.closest('[data-pbk-clear]')) { e.preventDefault(); clearAll(); return; }
    });

    /* フォーム入力（キーワード/価格/重量/鑑別書/セール/石種/カテゴリ/素材/号数/ネックレス長）→ 再描画 */
    if (filtersRoot) {
      var form = filtersRoot.querySelector('[data-pbk-form]');
      if (form) {
        form.addEventListener('submit', function (e) { e.preventDefault(); render({ scroll: true }); });
        form.addEventListener('change', function () { render({ scroll: true }); });
      }
      var kwEl = filtersRoot.querySelector('[data-pbk-keyword]');
      if (kwEl) {
        var kwT;
        kwEl.addEventListener('input', function () {
          clearTimeout(kwT);
          kwT = setTimeout(function () { render({ scroll: true }); }, 200);
        });
      }
    }

    /* 並べ替え（操作行 + 追従バーの2箇所）→ 値を同期して再描画。
       select は不可視オーバーレイなので、表示は [data-pbk-sort-value] ラベルに選択肢テキストを反映する（loose と同期・レビュー #7） */
    var sortValueEls = [].slice.call(rootEl.querySelectorAll('[data-pbk-sort-value]'));
    function syncSortLabels(sel) {
      if (!sel || !sel.options || !sel.options[sel.selectedIndex]) return;
      var label = sel.options[sel.selectedIndex].text;
      sortValueEls.forEach(function (v) { v.textContent = label; });
    }
    sortEls.forEach(function (el) {
      el.addEventListener('change', function () {
        var v = el.value;
        sortEls.forEach(function (other) { if (other !== el) other.value = v; });
        syncSortLabels(el);
        render();
      });
    });
    if (sortEls.length) syncSortLabels(sortEls[0]);

    /* ESC で開いているパネル/ピッカーを閉じる */
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && openPanel) setPanel(null);
    });

    /* 追従UI の出し入れ + ワード ← の再配置 */
    window.addEventListener('scroll', updateSticky, { passive: true });
    var rt;
    window.addEventListener('resize', function () {
      updateSticky();
      clearTimeout(rt);
      rt = setTimeout(layoutWordBack, 150);
    });

    /* 動的フィルタ選択肢を実データから生成する（全項目）
       サイズ（リング号数 / ネックレス長）は Figma 3683:256211 準拠で静的（Liquid 側でハードコード）。
       選択肢生成（buildRingSizeList / buildNecklaceLengthRange）と facet 非表示（updateSizeFacet）は
       呼ばない＝常時表示。号数・チェーン長の突合は _ringSizes / _chainNum に対して従来どおり動的に行う。 */
    function buildAllFacets() {
      buildStoneList();
      buildCategoryList();
      buildMetalList();
      buildWordList();
    }

    /* 起動: フィルタ選択肢生成 → （必要なら残ページ結合を待って）1回だけ描画 → 追従UI判定 */
    buildAllFacets();
    updateSizeButtons();
    /* 言葉 pill の幅は Web フォント(ShueiGoKin)適用で変わり折返しごと変わる → 確定後に ← の逃げを再計算 */
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(layoutWordBack);
    }

    /* updateSticky は render の後（グリッド描画後）に呼ぶ。空グリッド時に呼ぶと footer が
       ビューポート内 → is-foot stale=true でボトムバーが最上部で隠れる回帰になる（レビュー #3・loose と同期） */
    function firstRender() {
      setLoading(false);
      render();
      updateSticky();
    }

    if (meta.total_pages && meta.total_pages > 1) {
      /* 1ページ目だけで先に描くと、残ページ結合後の再描画で並び順が入れ替わり
         「一覧が出た直後に別の並びへ切り替わる」二度描画になる。
         全件揃うまで描画を保留し、確定状態を1回だけ描く（loose と同期） */
      setLoading(true);
      var settled = false;
      var settle = function (extra) {
        if (settled) return;
        settled = true;
        if (extra && extra.length) {
          enrich(extra);
          allProducts = allProducts.concat(extra);
          buildAllFacets();
        }
        firstRender();
      };
      fetchRemainingPages(meta).then(settle, function () { settle(null); });
      /* 取得が詰まっても一覧が出ないままにはしない（1ページ目で確定描画） */
      setTimeout(function () { settle(null); }, 5000);
    } else {
      firstRender();
    }
  }

  function boot() {
    document.querySelectorAll('[data-pbk-jewelry]').forEach(initApp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
